import React, { useRef, useState } from "react";
import "./style.css";
import LabelSpan from "../LabelSpan";

export default function FileInput({
  label,
  required,
  className,
  multiple = false,
  accept,
  onChange,
  disabled,
}) {
  const inputRequired = required ? (
    <span className="danger">&nbsp;*</span>
  ) : null;
  const inputLabel = label ? (
    <LabelSpan>
      {label}
      {inputRequired}
    </LabelSpan>
  ) : null;

  const inputRef = useRef(null);
  const [dragging, setDragging] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const openDialog = () => {
    if (!disabled && inputRef.current) {
      inputRef.current.click();
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    const { files } = e.dataTransfer;
    if (!files || files.length === 0) return;
    const arr = Array.from(files);
    setSelectedFiles(arr);
    if (onChange) onChange({ target: { files } });
  };

  const removeFile = (name) => {
    const updated = selectedFiles.filter((f) => f.name !== name);
    setSelectedFiles(updated);
    if (onChange) {
      const dt = new DataTransfer();
      updated.forEach((f) => dt.items.add(f));
      onChange({ target: { files: dt.files } });
    }
  };

  return (
    <>
      {inputLabel}
      <div
        className={`dropzone ${dragging ? "dragging" : ""} ${className || ""}`}
        onClick={openDialog}
        onDragOver={(e) => {
          e.preventDefault();
          setDragging(true);
        }}
        onDragLeave={() => setDragging(false)}
        onDrop={handleDrop}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") openDialog();
        }}
      >
        <>
          Drag and drop files here or{" "}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              openDialog();
            }}
          >
            browse files
          </a>
        </>
        <input
          ref={inputRef}
          type="file"
          style={{ display: "none" }}
          multiple={multiple}
          accept={accept}
          onChange={(e) => {
            const files = e.target.files;
            const arr = Array.from(files);
            setSelectedFiles(arr);
            if (onChange) onChange(e);
          }}
          disabled={disabled}
        />
      </div>

      {selectedFiles.length > 0 && (
        <ul className="file-list">
          {selectedFiles.map((f) => (
            <li key={f.name}>
              {f.name}
              <button
                type="button"
                className="remove-button"
                onClick={() => removeFile(f.name)}
              >
                ×
              </button>
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
